import styled from "styled-components";
import { ValidateColorType } from "types/admin/AdminType";

export interface StyledCheckBadgeProps {
  $color: ValidateColorType;
  $textNoWrap: boolean;
}

const colorStyles = (props: { $color: ValidateColorType }) => {
  if (props.$color === "red") {
    return `
      var(--sys-red-1);
    `;
  } else if (props.$color === "blue") {
    return `
      var(--pri-blue-4);
    `;
  } else {
    return `
      var(--text-gray-3);
    `;
  }
};

export const StyledCheckBadge = styled.div<StyledCheckBadgeProps>`
  display: flex;
  align-items: center;
  padding: 0.4rem 0;
  gap: 0.4rem;
  white-space: ${({ $textNoWrap }) => ($textNoWrap ? "nowrap" : "normal")};
  color: ${colorStyles};
  font: var(--label-medium-400);
`;
